import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { SWITCH_SOURCE_HANDLES } from '../switchHandles';
import { SwitchNodeView } from '../views/SwitchNode';
import { SwitchSettings } from '../settings/SwitchSettings';

/**
 * Switchカードの定義
 * 入力値に応じて次に進む出力ハンドルを返す
 */
export const switchDefinition: NodeDefinition<'switch'> = {
  label: 'Switch',
  showInPalette: true,
  paletteColor: 'bg-indigo-100 border-indigo-500 text-indigo-700',
  miniMapColor: '#6366f1',
  defaultData: {
    label: 'Switch',
    matchValue1: '',
    matchValue2: '',
  },
  view: SwitchNodeView,
  settings: SwitchSettings,
  run: (node, ctx, log) => {
    const inputValue = String(ctx.lastValue ?? '');
    let selectedHandle: string = SWITCH_SOURCE_HANDLES.default;
    let branchLabel = 'どちらでもない';

    if (node.data.matchValue1 !== '' && inputValue === node.data.matchValue1) {
      selectedHandle = SWITCH_SOURCE_HANDLES.match1;
      branchLabel = 'ことば1と同じ';
    } else if (node.data.matchValue2 !== '' && inputValue === node.data.matchValue2) {
      selectedHandle = SWITCH_SOURCE_HANDLES.match2;
      branchLabel = 'ことば2と同じ';
    }

    log(`[Switch] "${inputValue}" -> ${branchLabel}`);
    return { nextHandle: selectedHandle, branchLabel };
  },
  help: {
    title: [t('Switch（'), r('分岐', 'ぶんき'), t('する）')],
    description: [
      r('受', 'う'),
      t('け'),
      r('取', 'と'),
      t('った「ことば」で、'),
      r('進', 'すす'),
      t('む'),
      r('道', 'みち'),
      t('を'),
      r('選', 'えら'),
      t('びます。「ことば1」とぴったり'),
      r('同', 'おな'),
      t('じなら「ことば1と'),
      r('同', 'おな'),
      t('じ」へ、「ことば2」とぴったり'),
      r('同', 'おな'),
      t('じなら「ことば2と'),
      r('同', 'おな'),
      t('じ」へ、ちがうときは「どちらでもない」へ'),
      r('進', 'すす'),
      t('みます。'),
    ],
  },
};
